// MapView for web/browser

import * as React from 'react';
import { InteractionManager, StyleSheet } from 'react-native';
import Constants from 'expo-constants';
import { Wrapper, Status } from "@googlemaps/react-wrapper";

// https://github.com/googlemaps/js-markerclusterer/pull/570
// https://github.com/googlemaps/js-markerclusterer/pull/640
import { MarkerClusterer, SuperClusterViewportAlgorithm } from "@googlemaps/markerclusterer";
//import { DefaultRenderer, MarkerClusterer, NoopAlgorithm, GridAlgorithm, SuperClusterAlgorithm, SuperClusterViewportAlgorithm } from "@googlemaps/markerclusterer";
//import { DefaultRenderer, MarkerClusterer, NoopAlgorithm, GridAlgorithm, SuperClusterAlgorithm } from "markerclustererfh";

//import { interpolateRgb } from "d3-interpolate";
import * as AppUtilities from "../context/AppUtilities";
import * as AppConstants from "../context/AppConstants";
import * as Location from 'expo-location';
import { useNavigation } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { AppContext } from "../context/AppContext";
import * as AppState from "../context/AppState";
import { MapSearch } from './MapSearch';
import { CustomActivityIndicator } from './CustomActivityIndicator';

// https://googlemaps.github.io/js-markerclusterer/public/renderers/

// DefaultRenderer

/*
class PinRenderer {
  render({ count, position }, stats) {
    return new google.maps.Marker({
      label: { text: String(count), color: "white", fontSize: "10px" },
      position,
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  }
}
*/

// Based on https://github.com/googlemaps/js-markerclusterer/blob/main/src/renderer.ts#L107
/*class CircleRenderer {
  constructor() {
    this.palette = interpolateRgb("red", "blue");
  }
  render({ count, position }, stats) {
    // use d3-interpolateRgb to interpolate between red and blue
    const color = this.palette(count / stats.clusters.markers.max);
    // create svg url with fill color
    const svg = window.btoa(`
      <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity=".8" r="70" />    
      </svg>`);
    // create marker using svg icon
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(45, 45),
      },
      label: {
        text: String(count),
        color: "rgba(255,255,255,0.9)",
        fontSize: "12px",
      },
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  }
}*/

/*class CircleRendererCustomized {
  render({ count, position }, stats) {
    return new google.maps.Marker({
      position,
      // https://developers.google.com/maps/documentation/javascript/symbols#properties
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: '#ff0000',
        strokeColor: '#ff0000',
        fillOpacity: 1,
        scale: 10, // width/height = 22*scale
      },
      label: {
        text: String(count),
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: "bold",
      },
      // adjust zIndex to be above other markers
      zIndex: google.maps.Marker.MAX_ZINDEX + count,
      optimized: true,
    });
  }
}*/

/*
const RED_CIRCLE_ICON = {
  url: "data:image/svg+xml;base64," + window.btoa(`
    <svg fill="#ff0000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <circle cx="120" cy="120" opacity=".8" r="70" />    
    </svg>
  `),
};
*/

const RED_CIRCLE_ICON = {
  url: "data:image/svg+xml;base64," + window.btoa(`
    <svg fill="#ff0000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
      <circle cx="120" cy="120" r="70" />    
    </svg>
  `),
};

const ICON_TEXT_COLOR = "#ffffff";
const ICON_TEXT_FONT_SIZE = "12px";
const ICON_TEXT_FONT_WEIGHT = "bold";

let PIN_SIZE = null;

// Might be called multiple times so check the status
// This is used because otherwise APIs like google.maps aren't loaded yet in the global scope
function googleMapsLoaderCallback(status, loader) {
  if (status == "SUCCESS") {
    if (!RED_CIRCLE_ICON.scaledSize) {
      RED_CIRCLE_ICON.scaledSize = new google.maps.Size(50, 50);
    }
    PIN_SIZE = new google.maps.Size(26, 38);
  }
}

class CircleRendererCustomized2 {
  render({ count, position }, stats) {
    return new google.maps.Marker({
      position,
      icon: RED_CIRCLE_ICON,
      label: {
        text: String(count),
        color: ICON_TEXT_COLOR,
        fontSize: ICON_TEXT_FONT_SIZE,
        fontWeight: ICON_TEXT_FONT_WEIGHT,
      },
      // markers with a larger count should be on top
      zIndex: google.maps.Marker.MAX_ZINDEX + count,

      // https://developers.google.com/maps/documentation/javascript/markers#optimize
      // Unclear exactly how this works, no perceivable performance difference, and the
      // docs state that the API will try to optimize when possible
      //optimized: true,
    });
  }
}

/*
// Based on https://github.com/googlemaps/js-markerclusterer/blob/main/src/renderer.ts#L107
class OrbedCircleRenderer {
  render({ count, position }, stats) {
    // create svg url with fill color

    // #ff0000 creates red; #0000ff creates blue

    const svg = window.btoa(`
      <svg fill="#ff0000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" opacity=".6" r="70" />
        <circle cx="120" cy="120" opacity=".3" r="90" />
        <circle cx="120" cy="120" opacity=".2" r="110" />
      </svg>`);

    // create marker using svg icon
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(45, 45),
      },
      label: {
        text: String(count),
        color: "rgba(255,255,255,0.9)",
        fontSize: "12px",
      },
      title: `Cluster of ${count} locations`,
      // adjust zIndex to be above other markers
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
    });
  }
}
*/

function MyMapComponent({ icons, mapPinOffsets, isFocused }) {
  const navigation = useNavigation();
  const mapDiv = React.useRef(null);
  const map = React.useRef(null);
  const infoWindowPopup = React.useRef(null);
  const deliveryImageWrapper = React.useRef(null);
  const locationButton = React.useRef(null);
  const { showPermanentSnack, showTemporarySnack, hideSnack, getLoginState, showSpinner, hideSpinner } = React.useContext(AppContext);
  const dispatch = useDispatch();
  const [clusterer, setClusterer] = React.useState();
  const locations = useSelector((state) => state.locations);
  const firstZoom = useSelector((state) => state.firstZoom);
  const detailedZoom = useSelector((state) => state.detailedZoom);
  const lightMode = useSelector((state) => state.lightMode);
  const extraDebug = useSelector((state) => state.extraDebug);
  const initialCenter = useSelector((state) => state.initialCenter);
  const initialZoom = useSelector((state) => state.initialZoom);
  const showZoomControls = useSelector((state) => state.showZoomControls);
  const shouldAskToMoveToCurrentLocation = useSelector((state) => state.shouldAskToMoveToCurrentLocation);
  const shouldShowSearch = useSelector((state) => state.shouldShowSearch);
  const moveMap = useSelector((state) => state.moveMap);
  const dataFilter = useSelector((state) => state.dataFilter);
  const lastProcessedDataFilterID = React.useRef(null);
  const [mapFullyLoaded, setMapFullyLoaded] = React.useState(false);
  const isFirstMapLoad = React.useRef(true);
  const lastGPSLocation = useSelector((state) => state.lastGPSLocation);
  const lastGPSMarker = React.useRef(null);
  const lastSearchMarker = React.useRef(null);

  // Once the div is ready, initialize the map
  React.useEffect(() => {
    if (mapDiv.current) {

      const rightIconsPosition = google.maps.ControlPosition.RIGHT_BOTTOM;

      // https://developers.google.com/maps/documentation/javascript/reference/map
      // https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions

      const mapOptions = {
        center: initialCenter,
        zoom: initialZoom,
        styles: AppConstants.MAP_FEATURES,
        streetViewControl: false,
        mapTypeControl: false, // Hide top left Map/Satellite buttons
        fullscreenControl: false,
        zoomControlOptions: {
          position: rightIconsPosition,
        },
      };

      if (!showZoomControls) {
        mapOptions.zoomControl = false;
      }

      map.current = new google.maps.Map(mapDiv.current, mapOptions);

      // GPS button
      locationButton.current = document.createElement("img");
      locationButton.current.src = icons[0].uri;
      locationButton.current.classList.add("custom-map-control-button");
      locationButton.current.style = "background-color: #fff; border: 0; border-radius: 2px; box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3); margin: 10px; padding: 8px; overflow: hidden; cursor: pointer;";
      locationButton.current.addEventListener("click", moveToGPSZoomed);
      map.current.controls[rightIconsPosition].push(locationButton.current);

      // Filter button
      /*const moreButton1 = document.createElement("img");
      moreButton1.src = icons[3].uri;
      moreButton1.classList.add("custom-map-control-button");
      moreButton1.style = "background-color: #fff; border: 0; border-radius: 2px; box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3); margin: 10px; padding: 8px; overflow: hidden; cursor: pointer;";
      moreButton1.addEventListener("click", async () => {
        navigation.navigate(AppConstants.SCREENS.FILTER);
      });
      map.current.controls[google.maps.ControlPosition.LEFT_CENTER].push(moreButton1);*/

      // Delivery truck button

      /*
      deliveryImageWrapper.current = document.createElement("div");
      deliveryImageWrapper.current.style = "cursor: pointer;";
      deliveryImageWrapper.current.addEventListener("click", async () => {
        navigation.navigate(AppConstants.SCREENS.DELIVERY_STACK);
      });
      const moreButton2 = document.createElement("img");
      moreButton2.src = icons[2].uri;
      moreButton2.classList.add("custom-map-control-button");
      moreButton2.style = "background-color: #fff; border: 0; border-radius: 2px; box-shadow: 0 1px 4px -1px rgba(0, 0, 0, 0.3); margin: 10px; padding: 8px; overflow: hidden; cursor: pointer;";
      deliveryImageWrapper.current.appendChild(moreButton2);
      deliveryCount.current = document.createElement("span");
      deliveryCount.current.textContent = "";
      deliveryCount.current.style = "";
      deliveryImageWrapper.current.appendChild(deliveryCount.current);
      map.current.controls[google.maps.ControlPosition.LEFT_TOP].push(deliveryImageWrapper.current);
      */

      // https://developers.google.com/maps/documentation/javascript/reference/info-window
      infoWindowPopup.current = new google.maps.InfoWindow({
        content: "",
        //disableAutoPan: true,
      });
      map.current.addListener("click", closeInfoPopup);
      map.current.addListener("idle", onMoveMapIdle);

      google.maps.event.addListenerOnce(map.current, 'tilesloaded', onTilesLoaded);
    }
  }, [mapDiv]);

  // Update the little badge on the delivery truck button
  /*
  React.useEffect(() => {
    if (deliveryCount.current && locations_online) {
      if (locations_online.length > 0) {
        deliveryCount.current.textContent = "" + locations_online.length;
        deliveryCount.current.style = "font-size: 13px; position: absolute; top: 5px; right: 5px; color: white; background-color: red; padding: 2px; border: 0; border-radius: 10px; min-width: 15px; text-align: center; font-weight: bold;";
      } else {
        deliveryCount.current.textContent = "";
        deliveryCount.current.style = "";
      }
    }
  }, [locations_online]);
  */

  React.useEffect(() => {
    AppUtilities.info("MapView lightMode status: " + lightMode);
    if (lightMode) {
      if (deliveryImageWrapper.current) {
        deliveryImageWrapper.current.style.setProperty("display", "none");
      }
      locationButton.current.style.setProperty("display", "none");
      const builtInImages = document.getElementsByClassName("gm-control-active");
      if (builtInImages && builtInImages.length > 0) {
        builtInImages[0].parentNode.style.setProperty("display", "none");
      }
    } else {
      if (deliveryImageWrapper.current) {
        deliveryImageWrapper.current.style.setProperty("display", "block");
      }
      locationButton.current.style.setProperty("display", "inline");
      const builtInImages = document.getElementsByClassName("gm-control-active");
      if (builtInImages && builtInImages.length > 0) {
        builtInImages[0].parentNode.style.setProperty("display", "inline");
      }
    }
  }, [lightMode]);

  async function moveToGPSZoomed() {
    moveToGPS(false);
  }

  async function moveToGPS(initialZoom) {
    AppUtilities.info("MapView.moveToGPS: initialMove: " + (initialZoom ? "true" : "false"));
    try {
      const location = await Location.getCurrentPositionAsync({});
      AppUtilities.info("MapView.moveToGPS: received location: " + AppUtilities.toJSONPretty(location));
      closeInfoPopup();
      map.current.panTo({ lat: location.coords.latitude, lng: location.coords.longitude });
      if (initialZoom) {
        map.current.setZoom(firstZoom);
      } else {
        map.current.setZoom(detailedZoom);
      }
      dispatch(AppState.createDispatch(AppConstants.DISPATCH.UPDATE_LAST_GPS_LOCATION, {
        lat: location.coords.latitude,
        lng: location.coords.longitude,
      }));
    } catch (e) {
      // User may have simply blocked the operation
      AppUtilities.info("MapView.moveToGPS: Error doing geolocation: " + AppUtilities.getErrors(e));
      try {
        if (!initialZoom) {
          if (e instanceof GeolocationPositionError) {
            // https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
            if (e.code == 1) {
              showTemporarySnack("Permission denied. Check your browser to enable geolocation permissions for this page and try again.");
            } else if (e.code == 2) {
              showTemporarySnack("Geolocation failed because your device's source of position returned an internal error.");
            } else if (e.code == 3) {
              showTemporarySnack("Geolocation failed because your device's source of position timed out.");
            }
          }
        }
      } catch (innerException) {
        AppUtilities.handleException(innerException, "MapView.moveToGPS inner");
      }
    }

    if (initialZoom) {
      await AppState.checkAndHandleInitialLoad(showTemporarySnack, () => navigation.navigate(AppConstants.SCREENS.LEARN));
    }
  }

  function closeInfoPopup() {
    if (infoWindowPopup.current) {
      try {
        infoWindowPopup.current.close();
      } catch (e) {
        AppUtilities.info("MapView.closeInfoPopup: Error closing popup: " + AppUtilities.getErrors(e));
      }
    } else {
      AppUtilities.info("MapView.closeInfoPopup: Error closing popup: " + AppUtilities.getErrors(e));
    }
  }

  function onMoveMapIdle() {
    if (map.current) {
      var center = map.current.getCenter();
      if (center) {
        const lat = center.lat();
        const lng = center.lng();
        //console.log("onMoveMapIdle " + lat + "," + lng);
        // https://developers.google.com/maps/documentation/javascript/reference/map#Map.getCenter
        dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_MAP_CENTER, {
          lat: lat,
          lng: lng,
        }));
      }
    }
  }

  async function onTilesLoaded() {
    AppUtilities.info("MapView.onTilesLoaded map finished loading tiles");
    setMapFullyLoaded(true);
  }

  // Once the tiles are loaded, then we can load the actual locations
  // Also used by search
  async function updateMapLocations() {
    try {
      showSpinner();
      hideSnack();

      AppUtilities.info("MapView.updateMapLocations fetching data");

      if (getLoginState() == AppConstants.LOGIN_STATE.LOGGED_IN_LOCALLY ||
          getLoginState() == AppConstants.LOGIN_STATE.LOGGED_IN_REMOTELY) {

        let response = await AppUtilities.fetchUnauthorized(
          "MapView.updateMapLocations",
          AppUtilities.getMainDataLink(dataFilter),
          "GET",
        );

        if (response.body) {
          hideSpinner();
          lastProcessedDataFilterID.current = dataFilter[AppConstants.SYNTHESIZED_TYPES.QUERY_ID[AppConstants.TYPE_KEYS.URL_KEY]];

          const locs = AppUtilities.postProcessResultsLocations(response.body);
          const locationsCount = Object.keys(locs).length;

          AppUtilities.info("MapView.updateMapLocations locations: " + locationsCount + ", online: " + response.body.locations_online.length);

          dispatch(AppState.createDispatch(AppConstants.DISPATCH.SET_INITIAL_DATA, {
            locations: locs,
            locations_online: response.body.locations_online,
            ads: response.body.ads,
          }));

          AppUtilities.checkSearchResults(locationsCount, showTemporarySnack);
        } else {
          throw new Error("Result body not found");
        }

        if (isFirstMapLoad.current) {
          isFirstMapLoad.current = false;

          if (shouldAskToMoveToCurrentLocation) {
            moveToGPS(true);
          }
          InteractionManager.runAfterInteractions(() => {
            AppUtilities.onFirstInitializedMap();
          });      
        }
      }
    } catch (e) {
      showPermanentSnack(AppUtilities.getErrors(e), "Retry", updateMapLocations);
      hideSpinner();
      AppUtilities.handleException(e, "MapView.updateMapLocations");
    }
  }

  React.useEffect(() => {
    if (map.current && locations) {

      const actualMarkers = [];

      /*
      google.maps.event.addListener(map.current, 'idle', function() {
        // https://developers.google.com/maps/documentation/javascript/reference/map#Map.getBounds
        // https://developers.google.com/maps/documentation/javascript/reference/coordinates#LatLngBounds
        var bounds = map.current.getBounds();
        console.log("MapView Google Maps idled");
        //console.dir(bounds);
        //returns an object with the NorthEast and SouthWest LatLng points of the bounds
        // remove the current markers from the map and the cluster object, 
        // and add the new ones along with their event handlers and re-add to the cluster object as well
      });
      */

      for (const [key, marker] of Object.entries(locations)) {
        const actualMarker = new google.maps.Marker({
          position: {
            lat: marker.l,
            lng: marker.g,
          },
          // Some strange rendering issues
          //icon: {
          //  url: icons[mapPinOffsets[marker.p ? AppConstants.MAP_PIN_TYPES[marker.p] : AppConstants.MAP_PIN_NAMES.GENERIC]].uri,
          //  scaledSize: PIN_SIZE,
          //},
          icon: icons[mapPinOffsets[marker.p ? AppConstants.MAP_PIN_TYPES[marker.p] : AppConstants.MAP_PIN_NAMES.GENERIC]].uri,
          title: marker.t,
        });
        //actualMarker.addListener("click", clickHandler);

        actualMarker.addListener("click", () => {
          infoWindowPopup.current.setContent(`
            <div
              onclick="document.dispatchEvent(new CustomEvent('map-info-click', { 'detail': '${key}' })); return false;"
              class="mapInfoPopup"
            >
              <h3 style="text-align: center;">${AppUtilities.escapeHTML(marker.t)}${extraDebug ? " (" + marker.i + ")" : ""}</h3>
              <p>List certified products</p>
            </div>
          `);

          // https://developers.google.com/maps/documentation/javascript/reference/info-window#InfoWindow.open
          // https://developers.google.com/maps/documentation/javascript/reference/info-window#InfoWindowOpenOptions
          infoWindowPopup.current.open({
            map: map.current,
            anchor: actualMarker,
            // Otherwise the close button gets focus and a blue border
            shouldFocus: false,
          });
          map.current.panTo(actualMarker.getPosition());
        });

        actualMarkers.push(actualMarker);
      }

      if (lastSearchMarker.current) {
        actualMarkers.push(lastSearchMarker.current);
      }
      if (lastGPSMarker.current) {
        actualMarkers.push(lastGPSMarker.current);
      }

      // https://googlemaps.github.io/js-markerclusterer/interfaces/MarkerClustererOptions.html
      if (!clusterer) {
        let newClusterer = new MarkerClusterer({
          map: map.current,
          markers: actualMarkers,
          //renderer: new DefaultRenderer(),
          renderer: new CircleRendererCustomized2(),
          //renderer: new OrbedCircleRenderer(),
          //algorithm: new NoopAlgorithm(),
          //algorithm: new GridAlgorithm({}),
          //algorithm: new SuperClusterAlgorithm({}),
          algorithm: new SuperClusterViewportAlgorithm({
            maxZoom: 17, // In case pins overlap
            viewportPadding: 60,
          }),
        });

        google.maps.event.addListener(newClusterer, 'click', function(cluster) {
          // If the info window is open, we have to close it first before
          // the clusterer can zoom in
          closeInfoPopup();
        });

        setClusterer(newClusterer);
      } else {
        clusterer.clearMarkers();
        clusterer.addMarkers(actualMarkers);
      }
    }
  }, [locations]);

  React.useEffect(() => {
    if (locations) {

      const mapInfoClick = (e) => {
        const marker = locations[e.detail];
        if (marker && marker.i && !marker.i.toString().startsWith("cluster")) {
          navigation.navigate(AppConstants.SCREENS.LOCATION_DETAILS, { locationid: marker.i });
        }
      };

      const keydownHandler = (e) => {
        if(e.keyCode == 27) {
          // ESC pressed
          closeInfoPopup();
        }
      };

      document.addEventListener("map-info-click", mapInfoClick);
      document.addEventListener("keydown", keydownHandler);

      return () => {
        document.removeEventListener("map-info-click", mapInfoClick);
        document.removeEventListener("keydown", keydownHandler);
      };
    }
  }, [locations]);

  React.useEffect(() => {
    if (moveMap && map.current) {
      map.current.panTo({ lat: moveMap.latitude, lng: moveMap.longitude });
      map.current.setZoom(moveMap.zoom);

      if (clusterer) {
        if (lastSearchMarker.current) {
          clusterer.removeMarker(lastSearchMarker.current);
        }
        lastSearchMarker.current = new google.maps.Marker({
          position: {
            lat: moveMap.latitude,
            lng: moveMap.longitude,
          },
          // Some strange rendering issues
          //icon: {
          //  url: icons[mapPinOffsets[AppConstants.MAP_PIN_NAMES.SEARCH]].uri,
          //  scaledSize: PIN_SIZE,
          //},
          icon: icons[mapPinOffsets[AppConstants.MAP_PIN_NAMES.SEARCH]].uri,
          title: moveMap.description,
          cursor: "help",
        });
        clusterer.addMarker(lastSearchMarker.current);
      }
    }
  }, [moveMap, clusterer]);

  React.useEffect(() => {
    if (dataFilter && mapFullyLoaded && isFocused && lastProcessedDataFilterID.current != dataFilter[AppConstants.SYNTHESIZED_TYPES.QUERY_ID[AppConstants.TYPE_KEYS.URL_KEY]]) {
      updateMapLocations();
    }
  }, [dataFilter, mapFullyLoaded, isFocused]);

  React.useEffect(() => {
    if (lastGPSLocation && clusterer) {
      if (lastGPSMarker.current) {
        clusterer.removeMarker(lastGPSMarker.current);
      }
      lastGPSMarker.current = new google.maps.Marker({
        position: {
          lat: lastGPSLocation.lat,
          lng: lastGPSLocation.lng,
        },
        // Some strange rendering issues
        //icon: {
        //  url: icons[0].uri,
        //  size: new google.maps.Size(25, 25),
        //},
        icon: icons[0].uri,
        clickable: false,
      });
      clusterer.addMarker(lastGPSMarker.current);
    }
  }, [lastGPSLocation, clusterer]);

  return (
    <>
      <div ref={mapDiv} style={StyleSheet.absoluteFillObject} />
      {
        shouldShowSearch ?
            <MapSearch
              floatPaddingLeft={150}
              floatPaddingRight={150}
            />
          :
            null
      }
    </>
  );
}

export function MapView({ icons, isFocused, mapPinOffsets }) {
  const renderNonMap = (status) => {
    if (status == Status.LOADING) {
      //return <h3>Loading...</h3>;
      return <CustomActivityIndicator />;
    }

    // Return null on Status.SUCCESS and no need to handle Status.FAILURE as Google Maps will render:
    //   Oops! Somethin went wrong.
    //   This page didn't load Google Maps correctly. See the JavaScript console for technical details.
    return null;
  };

  return (
    <Wrapper apiKey={Constants.expoConfig.extra.googleWebApiKey} render={renderNonMap} callback={googleMapsLoaderCallback}>
      <MyMapComponent icons={icons} isFocused={isFocused} mapPinOffsets={mapPinOffsets} />
    </Wrapper>
  );
}
